import Utils from '../index'
import store from '../../store'
import { signOut } from '../../store/slices/authSlice'

class UserHelper {
  static checkUserInfo = () => {
    try {
      const userData = localStorage.getItem('user_data')

      // if (Utils.isEmpty(userData) || userData === '{}') throw Error('유저정보가 존재하지 않음')
      if (Utils.isEmpty(userData) || userData === '{}' || userData === "undefined") throw Error('유저정보가 존재하지 않음')
    } catch (e) {
      store.dispatch(signOut())
    }
  }

  // 특정 역할을 가지고 있는지 확인
  static hasRole(role) {
    UserHelper.checkUserInfo()
    const authorities = JSON.parse(localStorage.getItem('user_data'))?.roles

    return authorities.some(authority => authority === role)
  }

  /**
   * 주어진 역할 중 하나라도 가지고 있는지 확인
   *
   * @param {string[]} roles - 확인할 역할들
   * @returns {boolean} - 주어진 역할 중 하나라도 가지고 있으면 true
   */
  static hasAnyRole(roles) {
    UserHelper.checkUserInfo()
    return roles.some(role => this.hasRole(role))
  }

  static userInfo() {
    UserHelper.checkUserInfo()
    const userInfo = JSON.parse(localStorage.getItem('user_data'))

    return userInfo
  }
}

export default UserHelper
